import type { GetFavouritesResponseDto, CreateFavouriteDto, UpdateFavouriteDto, DeleteFavouriteParamsDto, UpdateFavouriteParamsDto, ReorderFavouritesDto, CreateFavouriteResponseDto, DeleteFavouriteResponseDto, UpdateFavouriteResponseDto, ReorderFavouritesResponseDto, GetFavouriteDto } from "@server/routes/favourites/dto";

export const getFavourites = async (page: number = 1, limit: number = 10): Promise<GetFavouritesResponseDto> => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  
  const response = await fetch(`/api/favourites?${params}`);
  if (!response.ok) {
    throw new Error("Failed to get favourites");
  }
  return response.json();
};  

export const getFavouriteByUrl = async (url: string): Promise<GetFavouriteDto> => {
  const response = await fetch(`/api/favourites/url/${encodeURIComponent(url)}`);
  if (!response.ok) {
    throw new Error("Failed to get favourite by url");
  }
  return response.json();
};

export const createFavourite = async (favourite: CreateFavouriteDto): Promise<CreateFavouriteResponseDto> => {
  const response = await fetch("/api/favourites", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(favourite),
  });

  if (!response.ok) {
    throw new Error("Failed to create favourite");
  }

  return response.json();
};

export const updateFavourite = async (id: number, favourite: UpdateFavouriteDto): Promise<UpdateFavouriteResponseDto> => {
  const response = await fetch(`/api/favourites/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(favourite),
  });

  if (!response.ok) {
    throw new Error("Failed to update favourite");
  }

  return response.json();
};

export const deleteFavourite = async (id: number): Promise<DeleteFavouriteResponseDto> => {   
  const response = await fetch(`/api/favourites/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Failed to delete favourite");
  }

  return response.json();
};

export const reorderFavourites = async (favouriteOrders: ReorderFavouritesDto["favouriteOrders"]): Promise<ReorderFavouritesResponseDto> => {
  const response = await fetch("/api/favourites/reorder", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ favouriteOrders }),
  });

  if (!response.ok) {
    throw new Error("Failed to reorder favourites");
  }

  return response.json();
};
